import React, { useState } from "react";
import { Col, Input, Label, Row, TabPane, Spinner, Button } from "reactstrap";
import { toast } from "react-toastify";
import { APIClient } from "../../../../helpers/api_helper";

const apiClient = new APIClient();

const TabRelatorio = () => {
  const [loading, setLoading] = useState(false);

  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");

  const [loadingAcam, setLoadingAcam] = useState(false);
  const [dataInicioAcam, setDataInicioAcam] = useState("");
  const [dataFimAcam, setDataFimAcam] = useState("");

  const [loadingDecripto, setLoadingDecripto] = useState(false);
  const [dataInicioDecripto, setDataInicioDecripto] = useState("");
  const [dataFimDecripto, setDataFimDecripto] = useState("");

  const handleExportCSV = async () => {
    setLoading(true);
    const params = {};

    if (dataInicio) params.data_inicio = dataInicio;
    if (dataFim) params.data_fim = dataFim;

    const response = await apiClient.get("/cripto-td/export-csv", params);

    if (response.sucesso) {
      const csvContent = response.dados;

      const blob = new Blob([csvContent], { type: "text/csv" });
      const blobURL = window.URL.createObjectURL(blob);

      const fileName = `compras-diarias_${dataInicio}_${dataFim}.csv`;
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = fileName;
      link.click();

      window.URL.revokeObjectURL(blobURL);
      setDataFim("");
      setDataInicio("");
    } else {
      toast.error(response.mensagem);
    }
    setLoading(false);
  };

  const handleExportAcam = async () => {
    setLoadingAcam(true);
    const params = {};

    if (dataInicioAcam) params.data_inicio = dataInicioAcam;
    if (dataFimAcam) params.data_fim = dataFimAcam;

    const response = await apiClient.get("/cripto-td/relatorio-acam", params);

    if (response.sucesso) {
      const csvContent = response.dados;

      const blob = new Blob([csvContent], { type: "text/csv" });
      const blobURL = window.URL.createObjectURL(blob);

      const fileName = `relatorio-acam_${dataInicioAcam}_${dataFimAcam}.csv`;
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = fileName;
      link.click();

      window.URL.revokeObjectURL(blobURL);
      setDataFimAcam("");
      setDataInicioAcam("");
    } else {
      toast.error(response.mensagem);
    }
    setLoadingAcam(false);
  };

  const handleExportDecripto = async () => {
    setLoadingDecripto(true);
    const params = {};

    if (dataInicioDecripto) params.data_inicio = dataInicioDecripto;
    if (dataFimDecripto) params.data_fim = dataFimDecripto;

    const response = await apiClient.get("/cripto-td/relatorio-decripto", params);

    if (response.sucesso) {
      const csvContent = response.dados;

      const blob = new Blob([csvContent], { type: "text/csv" });
      const blobURL = window.URL.createObjectURL(blob);

      const fileName = `relatorio-decripto_${dataInicioDecripto}_${dataFimDecripto}.csv`;
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = fileName;
      link.click();

      window.URL.revokeObjectURL(blobURL);
      setDataFimDecripto("");
      setDataInicioDecripto("");
    } else {
      toast.error(response.mensagem);
    }
    setLoadingDecripto(false);
  };

  return (
    <TabPane tabId="2">
      <Row>
        <div className="mb-3">
          <h5>Compras Diárias</h5>
        </div>
        {loading ? (
          <Col lg={12}>
            <Spinner />
          </Col>
        ) : (
          <>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Data Início</Label>
                <Input
                  type="date"
                  value={dataInicio}
                  onChange={(e) => setDataInicio(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Data Fim</Label>
                <Input
                  type="date"
                  value={dataFim}
                  onChange={(e) => setDataFim(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <Button
                  color="primary"
                  className="btn mb-4"
                  disabled={loading}
                  onClick={handleExportCSV}
                >
                  Exportar CSV
                </Button>
              </div>
            </Col>
          </>
        )}
      </Row>
      <hr />
      <Row>
        <div className="mb-3">
          <h5>Relatório Acam</h5>
        </div>
        {loadingAcam ? (
          <Col lg={12}>
            <Spinner />
          </Col>
        ) : (
          <>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Data Início</Label>
                <Input
                  type="date"
                  value={dataInicioAcam}
                  onChange={(e) => setDataInicioAcam(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Data Fim</Label>
                <Input
                  type="date"
                  value={dataFimAcam}
                  onChange={(e) => setDataFimAcam(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="alert alert-warning py-2 mb-3" role="alert">
                <small>O intervalo máximo permitido é de 31 dias.</small>
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <Button
                  color="primary"
                  className="btn mb-4"
                  disabled={loadingAcam}
                  onClick={handleExportAcam}
                >
                  Exportar CSV
                </Button>
              </div>
            </Col>
          </>
        )}
      </Row>
      <hr />
      <Row>
        <div className="mb-3">
          <h5>Relatório Decripto</h5>
        </div>
        {loadingDecripto ? (
          <Col lg={12}>
            <Spinner />
          </Col>
        ) : (
          <>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Data Início</Label>
                <Input
                  type="date"
                  value={dataInicioDecripto}
                  onChange={(e) => setDataInicioDecripto(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Data Fim</Label>
                <Input
                  type="date"
                  value={dataFimDecripto}
                  onChange={(e) => setDataFimDecripto(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="alert alert-warning py-2 mb-3" role="alert">
                <small>O intervalo máximo permitido é de 31 dias.</small>
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <Button
                  color="primary"
                  className="btn mb-4"
                  disabled={loadingDecripto}
                  onClick={handleExportDecripto}
                >
                  Exportar CSV
                </Button>
              </div>
            </Col>
          </>
        )}
      </Row>
    </TabPane>
  );
};

export default TabRelatorio;
